export default "__VITE_ASSET__ZTcS35A6__"